import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOthers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 98,
	height: 67,
	viewBox: "0 0 98 67",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 43.0249,
			y1: 10.9032,
			x2: 78.0249,
			y2: 19.9032,
			stroke: "#777777",
			strokeWidth: .2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 20.006,
			y1: 54.9002,
			x2: 74.0846,
			y2: 58.1551,
			stroke: "#777777",
			strokeWidth: .2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 13.9345,
			y1: 41.5211,
			x2: 25.9099,
			y2: 16.9562,
			stroke: "#777777",
			strokeWidth: .2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 20.9629,
			y1: 48.9072,
			x2: 40.9629,
			y2: 40.9072,
			stroke: "#777777",
			strokeWidth: .2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 59.9629,
			y1: 33.9072,
			x2: 79.9629,
			y2: 25.9072,
			stroke: "#777777",
			strokeWidth: .2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 45.9168,
			y1: 29.0555,
			x2: 37.9168,
			y2: 17.0555,
			stroke: "#777777",
			strokeWidth: .2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 74.9445,
			y1: 52.0832,
			x2: 59.9445,
			y2: 42.0832,
			stroke: "#777777",
			strokeWidth: .2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 85.9005,
			y1: 47.9898,
			x2: 87.9534,
			y2: 27.99,
			stroke: "#777777",
			strokeWidth: .2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 51,
			cy: 37,
			r: 11,
			fill: "#DFF2F1"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_16121_535)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M44.5 34H57.5L51 30L44.5 34Z",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M46.5 34V39",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.5 34V39",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M52.5 34V39",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M55.5 34V39",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M45 39H57",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M44 41H58",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11,
			cy: 51,
			r: 11,
			fill: "#FAEFDD"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_16121_535)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M4.5 48H17.5L11 44L4.5 48Z",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.5 48V53",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.5 48V53",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.5 48V53",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.5 48V53",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5 53H17",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4 55H18",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 87,
			cy: 23,
			r: 11,
			fill: "#F9E4F5"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip2_16121_535)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M80.5 20H93.5L87 16L80.5 20Z",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M82.5 20V25",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M85.5 20V25",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M88.5 20V25",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M91.5 20V25",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M81 25H93",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M80 27H94",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 83,
			cy: 56,
			r: 11,
			fill: "#F7E4DD"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip3_16121_535)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M76.5 53H89.5L83 49L76.5 53Z",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M78.5 53V58",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M81.5 53V58",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M84.5 53V58",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M87.5 53V58",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M77 58H89",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M76 60H90",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 34,
			cy: 11,
			r: 11,
			fill: "#D3DDF2"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip4_16121_535)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M27.5 8H40.5L34 4L27.5 8Z",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.5 8V13",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32.5 8V13",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M35.5 8V13",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.5 8V13",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28 13H40",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27 15H41",
					stroke: "#344054",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_16121_535",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 16,
					height: 16,
					fill: "white",
					transform: "translate(43 28)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip1_16121_535",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 16,
					height: 16,
					fill: "white",
					transform: "translate(3 42)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip2_16121_535",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 16,
					height: 16,
					fill: "white",
					transform: "translate(79 14)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip3_16121_535",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 16,
					height: 16,
					fill: "white",
					transform: "translate(75 47)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip4_16121_535",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 16,
					height: 16,
					fill: "white",
					transform: "translate(26 2)"
				})
			})
		] })
	]
});
export default SvgOthers;
